// feature flags

export const FEATURE_FLAG_ENUMS = {
  EXPAND_SPECIALIZED_WORKLOADS_ENABLED: "expand_specialized_workloads_enabled",
  FR_EXTENDS_INTERNAL: "fr_extends_internal",
  INTERNAL_FUND_REQUEST_LISTING_PARTITION:
    "internal_fund_request_listing_partition",
  DISPLAY_MDF_BANNER: "display_mdf_banner",
  DISPLAY_OPPORTUNITY_ID_HYPERLINK: "display_opportunity_id_hyperlink",
  CASH_CLAIM_ATTACHMENT_INTERNAL: "cash_claim_attachment_internal",
  NEW_SEARCH_BAR_INTERNAL_DASHBOARD: "new_search_bar_internal_dashboard",
  PIF_ENABLED: "pif_enabled",
  SELF_SERVICE_INTERNAL: "self_service_internal",
  SELF_SERVICE_AUDIT_CODE: "self_service_audit_code",
  SELF_SERVICE_REJECTION_REASON_CODE: "self_service_rejection_reason_code",
  SELF_SERVICE_FUND_REQUEST_MDF_ACTIVITY_TYPE:
    "self_service_fund_request_mdf_activity_type",
  SELF_SERVICE_HELPER_TEXT: "self_service_helper_text",
  SELF_SERVICE_AUTHORIZER: "self_service_authorizer",
  MPE_AND_ARR_VALIDATION_FOR_MAP_OPPORTUNITY:
    "mpe_and_arr_validation_for_map_opportunity",
  BULK_ACTIONS: "bulk_actions",
  BULK_ACTIONS_EXPIRE: "bulk_actions_expire",
  BULK_ACTIONS_UPDATE_INVOICE: "bulk_actions_update_invoice",
  HINDER_FC_SUBMISSION: "hinder_fc_submission",
  DISPLAY_MPE_RECORDS_table: "display_mpe_records_table",
  MAP_WF_MPE_POPULATION: "map_wf_mpe_population",
  ESTIMATED_REQUESTED_AMOUNT_USD: "estimated_requested_amount_usd",
  ISV_WMP_CONSENT_ENABLED: "isv_wmp_consent_enabled",
  USER_PERSISTED_SETTINGS_ENABLED: "user_persisted_settings_enabled",
  MAP_2024_ENABLED: "map_2024_enabled",
  OLD_MAP_DISABLED: "old_map_disabled",
  UPDATE_CLAIM_AMOUNT_INTERNAL_ENABLE: "update_claim_amount_internal_enable",
  PENDO_EXTERNAL_ENABLED: "pendo_external_enabled",
  BULK_ACTIONS_MAP_UNLOCK: "bulk_actions_map_unlock",
  VMWARE_MAP_ENABLED: "vmware_map_enabled",
  VMWARE_BONUS_MSP_OPTION_ENABLED: "vmware_bonus_msp_option_enabled",
  MAP_FR_EXTERNAL_EXTENDS: "map_fr_external_extends",
  MAP_FR_INTERNAL_EXTENDS: "map_fr_internal_extends",
  EDIT_AWS_ID_EXTERNAL_MODAL_ENABLED: "edit_aws_id_external_modal_enabled",
  AIBA_FRONTEND_ENABLED: "aiba_frontend_enabled",
  AIBA_ASYNC_ENABLED: "aiba_async_enabled",
  AIBA_CALCBUSTER_FRONTEND_ENABLED: "aiba_calcbuster_frontend_enabled",
  AIBA_PARTNER_FUNDING_PROFILE_ENABLED: "aiba_partner_funding_profile_enabled",
  AWS_JUMPSTART_PROGRAM_DISABLED: "aws_jumpstart_program_disabled",
  VMWARE_BONUS_CLAIM_CLAIM_ADJUSTMENT: "vmware_bonus_claim_claim_adjustment",
  SCA_FUNDING_ENABLED: "sca_funding_enabled",
  ENABLE_SCA_P1_PROGRAMS: "enable_sca_p1_programs",
  INTERNAL_ATTACHMENT_UPLOAD_PARTNERS_BEHALF:
    "internal_attachment_upload_partners_behalf",
  AGI_DETERMINISTIC_DUPE_CHECKS_ENABLED:
    "agi_deterministic_dupe_checks_enabled",
  RENAME_MISC_TO_ISV_ENABLED: "rename_misc_to_isv_enabled",
  SIMPLIFY_ISV_CREDIT_REQUEST_ENABLED: "simplify_isv_credit_request_enabled",
  EXISTING_WORKLOAD_AND_ARR_CALC_TYPE_ENABLED:
    "existing_workload_and_arr_calc_type_enabled",
  AGI_NON_DETERMINISTIC_DUPE_CHECKS_ENABLED:
    "agi_non_deterministic_dupe_checks_enabled",
  SCA_HARD_VALIDATIONS_ENABLED: "sca_hard_validations_enabled",
  MPOPP_ENABLED: "mpopp_enabled",
  MPOPP_VALIDATIONS_ENABLED: "mpopp_validations_enabled",
  CCS_MAP_CLAIM_UNLOCK: "ccs_map_claim_unlock",
  AIBA_MDF_EVALUATION_ENABLED: "aiba_mdf_evaluation_enabled",
  FE_POLICY_UPDATED_BANNER_ENABLED: "fe_policy_updated_banner_enabled",
  FE_APID_BANNER_ENABLED: "fe_apid_banner_enabled",
  APID_VALIDATION_ENABLED: "apid_validation_enabled",
  FE_PC2_MIGRATION_DEADLINE_BANNER_ENABLED:
    "fe_pc2_migration_deadline_banner_enabled",
  SHOW_PO_ALLOC_EXPIRED_STATUS: "show_po_alloc_expired_status",
  ENABLE_BEDROCK_ARR: "enable_bedrock_arr",
};
